import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import { APP_URL } from "config";

// Confirmation page for the Allowlisting Sync connect flow. The auth-service
// callback completes the connect server-side, then redirects the browser here
// with ?status=success|error (and ?domain= on success). This page only reports
// the outcome and returns the admin to settings; it makes no API call itself.
//
// Unlike Safe Sender, the Exchange changes run asynchronously after consent and
// take minutes, so the copy points the admin at the status panel rather than
// implying the work is already done.
const AllowlistConnected = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const status = params.get("status");
    const domain = params.get("domain");
    const success = status === "success";

    const [snackbarOpen, setSnackbarOpen] = useState(true);

    useEffect(() => {
        const redirectTimer = setTimeout(() => {
            window.location.href = `${APP_URL}/settings`;
        }, 3000);

        return () => clearTimeout(redirectTimer);
    }, []);

    const message = success
        ? `Allowlisting Sync connected successfully${domain ? ` for ${domain}` : ""}. We are now applying the allowlisting changes, which takes a few minutes. Check the Allowlisting Sync tab for progress. Redirecting to settings...`
        : "Allowlisting Sync could not be connected. Redirecting to settings...";

    return (
        <>
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <p>{message}</p>
                </div>
            </div>

            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={success ? "success" : "error"}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default AllowlistConnected;
